export const APP_SETTINGS = {
  "settings": [
    {
      "id": 2,
      "name": "techworks",
      "title": "Технические работы",
      "data": {
          "state": false
      },
      "priority": 0,
      "createdAt": "2022-06-21T08:17:31.907Z",
      "updatedAt": "2024-09-02T07:38:26.904Z"
    },
  ],
  "state": 1
}